/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerCreatedBy } from './get-card-monthly-transactions200-response-merged-transaction-detail-list-inner-evidence-list-inner-created-by';
// May contain unused imports in some cases
// @ts-ignore
import { GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors } from './get-card-monthly-transactions200-response-merged-transaction-detail-list-inner-evidence-list-inner-errors';
// May contain unused imports in some cases
// @ts-ignore
import { GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer } from './get-card-monthly-transactions200-response-merged-transaction-detail-list-inner-evidence-list-inner-invoice-issuer';
// May contain unused imports in some cases
// @ts-ignore
import { GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerUpdatedBy } from './get-card-monthly-transactions200-response-merged-transaction-detail-list-inner-evidence-list-inner-updated-by';
// May contain unused imports in some cases
// @ts-ignore
import { GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerUploadedBy } from './get-card-monthly-transactions200-response-merged-transaction-detail-list-inner-evidence-list-inner-uploaded-by';
// May contain unused imports in some cases
// @ts-ignore
import { GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings } from './get-card-monthly-transactions200-response-merged-transaction-detail-list-inner-evidence-list-inner-warnings';

/**
 * 
 * @export
 * @interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
 */
export interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner {
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'cardTransactionEvidenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'paymentType': GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'fileExtension': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'electronicMethod': GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'documentSize': GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'dpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'detectedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'calculatedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'colorGradation': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'verticalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'horizontalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'legalValidity': GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'dpiForciblyValid': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'colorGradationForciblyValid': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'note': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'irrelevantToLedger': boolean;
    /**
     * 
     * @type {GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'invoiceIssuer': GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'dpiError': GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'detectedDpiError': GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'calculatedDpiError': GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'colorGradationError': GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'heightMillisError': GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'widthMillisError': GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum;
    /**
     * 
     * @type {GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'errors': GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors;
    /**
     * 
     * @type {GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'warnings': GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings;
    /**
     * 
     * @type {GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerCreatedBy}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'createdBy': GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerCreatedBy;
    /**
     * 
     * @type {GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerUpdatedBy}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'updatedBy': GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerUpdatedBy;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'updatedAt': string;
    /**
     * 
     * @type {GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerUploadedBy}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'uploadedBy': GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerUploadedBy;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'uploadedByRecipient': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'needsMigration': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'uploadedFrom': string;
}

export const GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum = {
    cardTransaction: 'CARD_TRANSACTION',
    paymentRequest: 'PAYMENT_REQUEST'
} as const;

export type GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum = typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum[keyof typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum];
export const GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum = typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum[keyof typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum];
export const GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum = typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum[keyof typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum];
export const GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum = {
    valid: 'VALID',
    invalid: 'INVALID',
    inputRequired: 'INPUT_REQUIRED',
    outOfTarget: 'OUT_OF_TARGET'
} as const;

export type GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum = typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum[keyof typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum];
export const GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum = typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum[keyof typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum];
export const GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum = typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum[keyof typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum];
export const GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum = typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum[keyof typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum];
export const GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum = typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum[keyof typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum];
export const GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum = typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum[keyof typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum];
export const GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum = typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum[keyof typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum];


